import React from 'react';
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import {CaseForms} from "../../../../helpers/enums";

import './FaiUnReclamoCase.scss';

const FaiUnReclamoCase = () => (
  <div className="FaiUnReclamoCase" data-testid="FaiUnReclamoCase">
    <CaseGenerator type={CaseForms.FaiUnReclamo}/>
  </div>
);


export default FaiUnReclamoCase;
